interface IConstantVars {
  prevX: number;
  prevY: number;
  currX: number;
  currY: number;
  drawFlag: boolean;
  moveFlag: boolean;
  lineColor: string;
  lineWidth: number;
  canvasArray: [];
  stepIndex: number;
}

// object for canvas variables
const vars: IConstantVars = {
  // when drawing, record the start point: prevX,Y
  prevX: 0,
  prevY: 0,
  // point after movement
  currX: 0,
  currY: 0,
  // allow to draw for mouse down
  drawFlag: false,
  // allow to set movement
  moveFlag: false,
  // default lien color
  lineColor: 'grey',
  // line width
  lineWidth: 4,
  canvasArray: [],
  stepIndex: -1,
};

export function setLineColor(LineColor: string) {
  // set up current penP
  vars.lineColor = LineColor;
}
export function drawCircle(
  e: MouseEvent,
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
) {
  const rect = canvas.getBoundingClientRect();
  const scaleX = canvas.width / rect.width;
  const scaleY = canvas.height / rect.height;

  vars.prevX = vars.currX;
  vars.prevY = vars.currY;
  vars.currX = (e.clientX - rect.left) * scaleX;
  vars.currY = (e.clientY - rect.top) * scaleY;

  ctx.strokeStyle = vars.lineColor;
  ctx.lineWidth = vars.lineWidth;
  ctx.beginPath();
  ctx.arc(vars.currX, vars.currY, 35, 0, 2 * Math.PI);
  ctx.stroke();
}

export const ignoreCanvasElements = (element: any) => {
  if (typeof element.className === 'object' && element.className.baseVal) {
    // Skip Brush Line
    if (element.className.baseVal.includes('recharts-brush')) {
      return true;
    }
    if (element.className.baseVal === 'recharts-layer recharts-line-dots') {
      return true;
    } else if (
      element.className.baseVal ===
        'recharts-layer recharts-cartesian-axis-tick' &&
      window.getComputedStyle(element).display === 'none'
    ) {
      return true;
    }
  }
  return false;
};

export function findxy(
  res: string,
  e: MouseEvent,
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
) {
  // calculate true point position by using scale.
  const rect = canvas.getBoundingClientRect();
  const scaleX = canvas.width / rect.width;
  const scaleY = canvas.height / rect.height;

  // when mousedown, set up start point and end point for drawing.
  if (res === 'down') {
    vars.prevX = vars.currX;
    vars.prevY = vars.currY;

    vars.currX = (e.clientX - rect.left) * scaleX;
    vars.currY = (e.clientY - rect.top) * scaleY;

    vars.moveFlag = true;
    vars.drawFlag = true;
    // record the path of mouse moving
    if (vars.drawFlag) {
      ctx.beginPath();
      ctx.strokeStyle = vars.lineColor;
      ctx.fillRect(vars.currX, vars.currY, 1, 1);
      ctx.closePath();
      vars.drawFlag = false;
    }
  }
  if (res === 'up' || res === 'out') {
    vars.moveFlag = false;
  }
  // if color is selected, draw the mouse move line.
  if (res === 'move' && vars.lineColor !== 'grey') {
    if (vars.moveFlag) {
      vars.prevX = vars.currX;
      vars.prevY = vars.currY;

      vars.currX = (e.clientX - rect.left) * scaleX;
      vars.currY = (e.clientY - rect.top) * scaleY;
      draw(ctx);
    }
  }
}

function draw(ctx: CanvasRenderingContext2D) {
  ctx.beginPath();
  ctx.moveTo(vars.prevX, vars.prevY);
  ctx.lineTo(vars.currX, vars.currY);
  ctx.strokeStyle = vars.lineColor;
  ctx.lineWidth = vars.lineWidth;
  ctx.stroke();
  ctx.closePath();
}

// Annotation padding are used to calculate the position of modal.
// we need to leave 200px on X, and 250px on Y to display annotation edit page.
export const AnnotationWidthPadding = 100;
export const AnnotationHeightPadding = 250;
export const MinMessageInputWidth = 200;

export const penColors = [
  '#d0021b',
  '#f5a623',
  '#8b572a',
  '#7ed321',
  '#bd10e0',
  '#4a90e2',
];
